import React from "react";
import { intelUpdates } from "../../data/intelligence";
import { formatUpdated } from "../../utils/intelligence";
export function RecentUpdates() {
  return <section aria-labelledby="updates-title" className="bg-navy text-ivory" data-id="element-389" data-mp="1aedhqdopzshb">
      <div className="shell py-24 md:py-32" data-id="element-390" data-mp="wkvxsrs4gdqr">
        <div className="grid grid-cols-12 gap-x-6 gap-y-12" data-id="element-391" data-mp="11jz5kjzhky2f">
          <div className="col-span-12 lg:col-span-4" data-id="element-392" data-mp="11i4hwxwtyrun">
            <p className="eyebrow text-ivory/75" data-id="element-393" data-mp="mmotb8f0ro5n">Recent updates</p>
            <h2 id="updates-title" className="mt-6 font-display text-[clamp(2.25rem,4vw,3.25rem)] leading-[1.06]" data-id="element-394" data-mp="rm1iw0x9z9bx">
              Kept current, and dated.
            </h2>
            <p className="mt-6 max-w-sm leading-relaxed text-ivory/70" data-id="element-395" data-mp="do4hmr7vmeqx">
              Every change is logged. When a rule moves, the guide moves with it — and clients affected hear from us.
            </p>
          </div>

          <ol className="col-span-12 border-t border-ivory/30 lg:col-span-8" data-id="element-396" data-mp="27ygg2yznk9q8">
            {intelUpdates.map(u => <li key={`${u.date}-${u.subject}`} className="grid grid-cols-12 items-baseline gap-x-4 gap-y-1 border-b border-ivory/15 py-5" data-id="element-397" data-mp="2lzuq7pd3i2o5">
                <span className="col-span-6 text-[13px] tabular-nums text-ivory/60 md:col-span-2" data-id="element-398" data-mp="2vpwf2jd9vp44">
                  {formatUpdated(u.date, "MMM d")}
                </span>
                <span className="col-span-6 text-right text-[11px] uppercase tracking-[0.12em] text-ivory/50 md:order-last md:col-span-3" data-id="element-399" data-mp="2qt5yluxk2ri6">
                  {u.type}
                </span>
                <span className="col-span-12 md:col-span-7" data-id="element-400" data-mp="1z1q299675qer">
                  <span className="font-display text-xl text-ivory" data-id="element-401" data-mp="2czy6811nhrzf">{u.subject}</span>
                  <span className="mt-1 block text-[15px] leading-relaxed text-ivory/75" data-id="element-402" data-mp="28021u0p1jyjc">{u.change}</span>
                </span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}